angular.module('saturn-growl.template', []);
require('../templates/templates.js');

var GrowlController = require('./GrowlController.js');
var GrowlDirective = require('./GrowlDirective.js');

angular
.module('saturn-growl', [
  'saturn-growl.template',
  'ngAnimate'
])
.controller('GrowlController', [
  '$scope',
  'SaturnGrowl',
  '$timeout',
  GrowlController
])
.directive('sbGrowl', [
  'SaturnGrowl',
  GrowlDirective
])
.service('SaturnGrowl', ['$rootScope', function($rootScope) {
  this.listen = function(callback) {
    $rootScope.$on("SB-GROWL-NEW", callback)
  };
  this.listenRemove = function(callback) {
    $rootScope.$on("SB-GROWL-REMOVE", callback)
  };
  this.newGrowl = function(message, config) {
    $rootScope.$emit("SB-GROWL-NEW", message, config)
  };
  this.removeGrowl = function(config) {
    $rootScope.$emit("SB-GROWL-REMOVE", config)
  };

  this.removeGrowlById = function(id) {
    $rootScope.$emit("SB-GROWL-REMOVE-BY-ID", id)
  }
}])



//////////////////
// WEBPACK FOOTER
// ./~/@skycatch/saturn-growl-booster/src/index.js
// module id = 765
// module chunks = 0